module.exports = __webpack_public_path__ + "static/media/evenbreeze-5.7396561e.jpg";